import React from 'react'
import { Card, Container } from 'semantic-ui-react'
import SEO from "../components/seo"
import Layout from "../components/layout"

import styles from '../styles/pages/servicios.module.scss'

const servicios = () => (
  <Layout>
    <SEO title="Home" />
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.info}>
          <h1>Nuestros Servicios</h1>
          <h2>Presenciales y Online</h2>
          <Card.Group centered>
            <Card>
              <Card.Content>
                <Card.Header>
                  Programas de Nutrición y Salud
            </Card.Header>
                <Card.Description>
                  <ul>
                    <li>Planes personalizados </li>
                    <li>Asesorías individuales o grupales</li>
                    <li>Sesiones de Coachig de Hábitos</li>
                  </ul>
                </Card.Description>
              </Card.Content>
            </Card>
          </Card.Group>
        </div>
      </Container>
    </div>
  </Layout>
)

export default servicios
